import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Redirect } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import LaunchIcon from '@material-ui/icons/Launch';

import Loading from 'shared/components/Loading';
import { logShareError } from 'shared/services/LogService';
import Gallery from 'app/components/Gallery';
import Nav from 'app/components/Nav';
import SelectionHeader from 'shared/components/SelectionHeader';

import {
  getGallery,
  getMoments
} from 'app/actions/galleryActions';

import {
  clearSelectionItems
} from 'shared/actions/selectionActions';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flex: 1,
    marginLeft: isMobile ? 0 : 'calc(20vw + 20px)',
    width: isMobile ? '100%' : '80vw',
    float: isMobile ? 'right' : 'none'
  },
  toolbar: {
    position: 'fixed',
    float: 'left',
    width: '100%',
    padding: '0.5rem'
  },
  logo: {
    float: 'left',
    height: '50px',
    width: 'auto',
    marginTop: '0.2rem',
    marginRight: '0.2rem'
  },
  headers: {
    float: 'left',
    padding: '1rem 0.5rem',
    width: '60%'
  },
  header: {
    float: 'left',
    width: '100%',
    textAlign: 'left',
    fontSize: '1.3rem'
  },
  subHeader: {
    float: 'left',
    width: '100%',
    textAlign: 'left',
    marginBottom: 0
  },
  gallery: {
    marginTop: isMobile ? '100px' : 0
  },
  launchIcon: {
    display: isMobile ? 'inline' : 'none',
    float: 'right',
    fontSize: '2.5rem',
    margin: '0 0.3rem'
  }
});

class Home extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      loading: true,
      notFound: false
    };
  }

  componentDidMount(){
    const { match: { params: { token } }, getGallery, getMoments } = this.props;

    if (!token) {
      this.setState({
        loading: false,
        notFound: true
      });
      return;
    }

    this.props.clearSelectionItems();

    getGallery(token)
    .then(() => {
      this.setState({
        loading: false
      });

      getMoments(token);
    });
  }

  shouldComponentUpdate(newProps, newState) {
    return this.state.loading !== newState.loading ||
      this.state.notFound !== newState.notFound;
  }

  componentDidCatch(error, info) {
    logShareError(error, info);
  }

  render() {
    if (this.state.loading) {
      return (
        <Loading />
      );
    }

    if (this.state.notFound) {
      return (<Redirect to="/404" />);
    }

    const { classes, gallery } = this.props;

    const logoUrl = gallery.logo_url || "/img/logo-violet.svg";

    const launchIcon = gallery.provider_website && (
      <a target="_blank" style={{color: '#333'}} href={gallery.provider_website}>
        <LaunchIcon className={classes.launchIcon} />
      </a>
    );

    return (
      <div className={classes.root}>
        <CssBaseline />
        <div className={classes.toolbar}>
          <img className={classes.logo} src={logoUrl} />
          <div className={classes.headers}>
            <h1 className={classes.header}>{gallery.story_name}</h1>
            <p className={classes.subHeader}>{gallery.provider_name}</p>
          </div>
          {launchIcon}
        </div>
        <main className={classes.content}>
          <div className={classes.gallery}>
            <Gallery forceVisible={true} />
          </div>
          <Nav />
        </main>
        <SelectionHeader />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  gallery: state.galleryReducer.gallery,
  moments: state.galleryReducer.moments
});

export default connect(mapStateToProps, { getGallery, getMoments, clearSelectionItems })(withStyles(styles, { withTheme: true })(withRouter(Home)));
